module.exports = __webpack_public_path__ + "static/media/icon_sorafa735d1ec56d929f1c06449efae34cf9.webp";